import { CAPEXPPTReport, CTBRequest, GTBRequest, PPTReport, PPTRulesResponse, UpdatePPTRulesDescriptionCategorisationRequest } from "./interfaces"

export enum AppPlatform {
    ActiveDirectoryDomain = "ActiveDirectoryDomain",
    Azure = "Azure"
}

export const FormEditMode = {
    CREATE: 1,
    EDIT: 2,
    VIEW: 3
}
export enum RoutePathNames {
    LOGIN = "login",
    USERS = "users",
    CTBRECORDS = "ctb-records",
    GTBRECORDS = "gtb-records",
    RECONCILIATIONRULES = "reconciliation-rules",
    CTBMAPPINGKEYS = "ctb-mapping-keys",
    GTBMAPPINGKEYS = "gtb-mapping-keys",
    REPORT_LIST = "reports-list",
    REPORT = "reports",
}

export enum BSPL {
    BS = "BS",
    PL = "PL",
  
}

export enum CTBObject {
    WBS = "WBS",
    CCT = "CCT",
  
}
export enum ReportType {
    CAPEX = "CAPEX",
    OPEX = "OPEX",
  
}
export enum isMapped {
    TRUE = "TRUE",
    FALSE = "FALSE",
  
}
export enum ReportDisplay {
    FORM ='Form',
    TABLE = "Table",
    VIEW  = "View"
   
}
export const emptyPPTRulesDescriptionCategorisationRequest:UpdatePPTRulesDescriptionCategorisationRequest = {
    pptRulesCategorisationId: '',
    isManualInput: false,
    pptClassificationIds: [],
    reconciliationIds: [],
    afsClassificationIds: [],
    pptRulesId: '',
    pptRulesDescriptionCategorisationId: '',
    isNegateValue: false,
    socialAccountMappingIds: []
}
export const emptyCTBRequest: CTBRequest = {
    costTrialBalanceId: '',
    pptClassificationId: '',
    afsClassificationId: '',
    reconciliationId: '',
    pptRamsesDescId: '',
    taxTermId: '',
    year: ""
}
export const emptyPPTRulesResponse: PPTRulesResponse = {
    pptReports: [],
    pptReportsFooter: []
}
export const emptyGTBRequest: GTBRequest = {
    generalTrialBalanceId:'',
    socialAccountMappingId: '',
    capId: '',
    bspl:'',
    cashODMapping: false,
    classificationId:'',
    cashFlowClassificationId: '',
    cashFlowMappingId: '',
}
export const emptyPPTReport:  PPTReport={
    id: '',
    title: '',
    subject: '',
    reportType: ReportType.OPEX,
    pptReportsDescription: [],
    pptReportsFooter: [],
    year: "",
    generatedBy: "",
    createdAt: new Date()
}
export const emptyCAPEXPPTReport:  CAPEXPPTReport={
    id: '',
    title: '',
    subject: '',
    reportType: ReportType.OPEX,
    pptReportsDescription: [],
    pptReportsFooter: []
}

export const ReportDescription = {
    COSTPERAUDITEDFINSTAT: "COSTS PER AUDITED FINANCIAL STATEMENT",
    COSTSINCLUDEDINPPTRETURNS: "COSTS INCLUDED IN PPT RETURNS BUT NOT IN AUDITED FINANCIAL STATEMENT",
    COSTSEXCLUDEDFROMPPTRETURNS: "COSTS IN AUDITED FINANCIAL STATEMENT BUT EXCLUDED FROM PPT RETURNS",
    COSTSREPORTEDINPPTRETURNS: "COST REPORTED IN THE PPT RETURNS",
}
export const CapexReportDescription = {
    ADDITIONSPERAUDITEDFINANCIALSTATEMENT: "ADDITIONS PER AUDITED FINANCIAL STATEMENT (AFS)",
    ADDITIONSINCLUDEDINPPTRETURNSBUTNOTINAUDITEDFINANCIALSTATEMENT: 'ADDITIONS INCLUDED IN PPT RETURNS BUT NOT IN AUDITED FINANCIAL STATEMENT',
    INTANGIBLEEXPLODEVELOPMENTCOST: "INTANGIBLE EXPLO & DEVELOPMENT COST",
    OTHERINTANGIBLEASSETS: "OTHER INTANGIBLE ASSETS",
    TANGIBLECOST: "TANGIBLE COST (QCE)",
}